const initialState = {
  projectReports: [],
  projectReport: null,
  total: 0,
  loading: false,
  error: null,
};

export const projectReportReducer = (state = initialState, action) => {
  switch (action.type) {

    case "PROJECT_REPORT_LIST_REQUEST":
      return { ...state, loading: true, error: null };
    case "PROJECT_REPORT_LIST_SUCCESS":
      return { ...state, loading: false, projectReports: action.payload.data || [], total: action.payload.total || 0, error: null };
    case "PROJECT_REPORT_LIST_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "PROJECT_REPORT_ADD_REQUEST":
      return { ...state, loading: true, error: null };
    case "PROJECT_REPORT_ADD_SUCCESS":
      return { ...state, loading: false, error: null };
    case "PROJECT_REPORT_ADD_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "PROJECT_REPORT_UPDATE_REQUEST":
      return { ...state, loading: true, error: null };
    case "PROJECT_REPORT_UPDATE_SUCCESS":
      return { ...state, loading: false, projectReport: action.payload.data || null, error: null };
    case "PROJECT_REPORT_UPDATE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "PROJECT_REPORT_STATUS_REQUEST":
      return { ...state, loading: true, error: null };
    case "PROJECT_REPORT_STATUS_SUCCESS":
      return { ...state, loading: false, error: null };
    case "PROJECT_REPORT_STATUS_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "PROJECT_REPORT_VIEW_REQUEST":
      return { ...state, loading: true, error: null };
    case "PROJECT_REPORT_VIEW_SUCCESS":
      return { ...state, loading: false, projectReport: action.payload.data || null, error: null };
    case "PROJECT_REPORT_VIEW_FAIL":
      return { ...state, loading: false, error: action.payload, projectReport: null };

    case "CLEAR_PROJECT_REPORT_ERRORS":
      return { ...state, error: null };

    default:
      return state;
  }
};